import React from 'react';
import { NavItem } from '../NavItem';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type NavItemData = {
  path:         string,
  text:         string,
  icon:         IconName,
  indent?:      boolean,
  isNotClickable?: boolean,
}

type NavListProps = {
  onItemClick?: () => void,
}

export const NavList: React.FC<NavListProps> = ({onItemClick}) => {
  const { pathname } = useLocation();

  const path = pathname.split('/');
  let currentPath = `/${(path.length > 1) ? path[1] : ''}`;
  if (currentPath === '/unit') {
    currentPath = '/locations';
  }

  const { t } = useTranslation();
  const navItems: NavItemData[] = [
    {
      path: '/',
      text: t('dashboard'),
      icon: 'home',
    },
    {
      path: '/locations',
      text: t('locations'),
      icon: 'map-marker-alt',
    },
    {
      path: '/alerts',
      text: t('alerts'),
      icon: 'bell',
    },
    {
      path: '/usage',
      text: t('water-usage'),
      icon: 'chart-line',
    },
    {
      path: '/users',
      text: t('users'),
      icon: 'user',
    },
    {
      path: '#',
      text: t('help'),
      icon: 'question-circle',
      isNotClickable: true,
    },
    {
      path: '/guide',
      text: t('getting-started'),
      icon: 'paper-plane',
      indent: true,
    },
    {
      path: '/faq',
      text: t('faq'),
      icon: 'comment',
      indent: true,
    },
    {
      path: '/support',
      text: t('support'),
      icon: 'headset',
      indent: true,
    },
  ];
  return (
    <>
      {
        navItems.map((item, index) =>
            <NavItem
              path    = {item.path}
              text    = {item.text}
              icon    = {item.icon}
              key     = {`nav-item-${index}`}
              active  = {currentPath === item.path}
              indent  = {item.indent}
              isNotClickable = {item.isNotClickable}
              onClick = {onItemClick}
            />
        )
      }
    </>
  );
};

export default NavList;
